<template>
    <div class="video">
       <aliPlayer clientType="pc"></aliPlayer>
    </div>
</template>
<script>
import aliPlayer from 'components/aliPlayer'
import psCommonMethods from './mixins/index.js'
export default {
  name: 'Video',
  mixins: [psCommonMethods],
  data () {
    return {
      source: '' // 视频地址
    }
  },
  created () {
    this.initData()
  },
  beforeDestroy () {
    this.$store.commit('video_finished', true)
  },
  computed: {
    video_finished () {
      return this.$store.state.video_finished
    }
  },
  watch: {
    video_finished (nv) {
      if (nv) { // 视频播放结束
        this.chapterTurn(1)
      }
    },
    '$route' () {
      this.initData()
      // this.setLessonLocation(this.$store.state.currentPartIndex, this.$store.state.currentChapterIndex)
    }
  },
  // mounted () { // 进入页面即是完成
  //   this.setLessonLocation(this.$store.state.currentPartIndex, this.$store.state.currentChapterIndex)
  // },
  methods: {
    initData () {
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      let data = this.data.part_list[pIndex].chapter_list[cIndex]
      this.source = data.file_path[0]
      this.$store.commit('video_url', this.source)
    }
  },
  components: {
    aliPlayer
  }

}
</script>
<style lang="less" scoped>
.video{
    height: 100%;
    padding: 0 40px;
}
</style>
